/**
 * Format a decimal-hour number (e.g. `1.42`) as "H:MM" (`1:25`).
 * Handles nulls/undefined by returning "0:00".
 *
 * Examples:
 *   formatHoursHM(0)     → "0:00"
 *   formatHoursHM(1.42)  → "1:25"
 *   formatHoursHM(0.5)   → "0:30"
 *   formatHoursHM(8)     → "8:00"
 *
 * The `withSuffix` variant appends the localized "س / د" label so
 * tooltips read naturally ("1 س و 25 د" / "1h 25m").
 */
export function formatHoursHM(hours) {
  const n = Number(hours);
  if (!Number.isFinite(n) || n <= 0) return '0:00';
  const totalMin = Math.round(n * 60);
  const h = Math.floor(totalMin / 60);
  const m = totalMin - h * 60;
  return `${h}:${String(m).padStart(2, '0')}`;
}

export function formatHoursHMLabeled(hours, isAr = true) {
  const n = Number(hours);
  if (!Number.isFinite(n) || n <= 0) return isAr ? '0 د' : '0m';
  const totalMin = Math.round(n * 60);
  const h = Math.floor(totalMin / 60);
  const m = totalMin - h * 60;
  if (h === 0) return isAr ? `${m} د` : `${m}m`;
  if (m === 0) return isAr ? `${h} س` : `${h}h`;
  return isAr ? `${h} س و ${m} د` : `${h}h ${m}m`;
}
